import { create } from './deferred';
import { create as _create } from '@analytics/patsnap-copilot/src/deferred';
import { CommonApis } from '@eureka/services/src/apis/common.api'

export enum EurekaProduct {
    /**
     * Eureka
     */
    GENERAL = 'GENERAL',
    /**
     * 材料
     */
    MATERIAL = 'MATERIAL'
}

export enum EurekaSelectedModule {
    STANDARD = 'STANDARD',
    AIR = 'AIR'
}

export enum EUploadCode {
    /**
     * IP范围
     */
    IPForbidden = 90113001,
    /**
     * 管理员
     */
    AdminForbidden = 90113002
}

export interface IControl {
    /**
     * 是否需要引导
     */
    need_guide: [],
    /**
     * 用户产品
     */
    product: EurekaProduct,
    /**
     * 邀请活动弹窗权限
     */
    activity: boolean,
    /**
     * AI交底书权限
     */
    ai_disclosure: boolean,
    /**
     * Chat权限
     */
    chat: boolean,
    /**
     * 立项权限
     */
    project: boolean,
    /**
    * 结构式
    */
    material_structure: boolean,
    /**
     * 技术想法查新
     */
    disclosure_check: boolean,
    /**
     * 是否已赋权材料试用
     */
    empowered_material_trial: boolean,
    /**
     * 是否是免费用户
     */
    freemium: boolean
    /**
     * 是否是试用用户
     */
    trial: boolean
    /**
    * 下载权限
    */
    download: boolean,
    /**
     * 上传权限
     */
    upload: boolean,
    /**
     * 上传被禁的原因（IP范围/管理员）
     * 只有上传禁止才会有这个字段
     */
    upload_code?: EUploadCode,
    /**
     * 基于{company}组织的策略，当前IP范围内不允许上传文件
     * 只有上传禁止才会有这个字段
     */
    company?: string[],
    /**
     * 当前选择的首页模块
     */
    selected_module: EurekaSelectedModule,
    /**
     * 是否有AIR功能
     */
    air_feature: boolean,
    /**
     * 是否有fmea权限
     */
    tech_fmea: boolean,
    /**
     * 用户是否处于AIR产品模式。
     * 如果用户是材料，即使选择了AIR，也不算AIR产品模式，算材料产品模式
     */
    is_air_product: boolean
    /**
     * 是否是material产品
     */
    is_material_product: boolean
    /**
     * 是否是standard产品
     */
    is_standard_product: boolean
}

export const controlDeferred = create<IControl>();

export const patsnapCopilotUpgradeInvite = _create<boolean>();

CommonApis.getGlobalControl().then(res => {
    /**
     * 是否是AIR产品
     */
    const { air_feature, selected_module, product } = res;
    const is_material_product = product === EurekaProduct.MATERIAL
    const is_air_product = !is_material_product && selected_module === EurekaSelectedModule.AIR && air_feature
    const is_standard_product = product === EurekaProduct.GENERAL
    controlDeferred.resolve({
        ...res,
        is_air_product,
        is_material_product,
        is_standard_product,
    })
    patsnapCopilotUpgradeInvite.resolve(res.activity);
    return res;
})
